<template>
    <div v-if="splitBlock.length > 1" class="d-inline">
        <span>{{ splitBlock[0] }}</span>
        <template v-if="isUrl(splitBlock[1])">
            <template v-if="splitBlock[1].slice(-1) === ' ' || splitBlock[1].slice(-1) === '　'">
                <a :href="splitBlock[1].slice(0, -1)" target="_blank">{{ splitBlock[1].slice(0, -1) }}</a><!--
             --><span>{{ splitBlock[1].slice(-1) }}</span>
            </template>
            <template v-else>
                <a :href="splitBlock[1]" target="_blank">{{ splitBlock[1] }}</a>
            </template>
        </template>
        <template v-else>
            <span>{{ splitBlock[1] }}</span>
        </template>
    </div>
    <div v-else-if="isUrl(block)" class="d-inline">
        <template v-if="block.slice(-1) === ' ' || block.slice(-1) === '　'">
            <a :href="block.slice(0, -1)" target="_blank">{{ block.slice(0, -1) }}</a><!--
         --><span>{{ block.slice(-1) }}</span>
        </template>
        <template v-else>
            <a :href="block" target="_blank">{{ block }}</a>
        </template>
    </div>
    <div v-else class="d-inline">
        <span>{{ block }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            block: {
                type: String,
                required: true,
            }
        },

        computed: {
            /**
             * ブロックをhttp(s)を区切り文字として分割
             * 区切り文字は分割直後の要素に含める
             *
             * ex1. あいうえおhttps://yokumiru.jp → ['あいうえお', 'https://yokumiru.jp']
             * ex2. https://yokumiru.jpあいうえお → ['https://yokumiru.jpあいうえお']
             *
             * @return {string[]}
             */
            splitBlock: function () {
                // 区切り文字は分割直後の要素に含める (?=)
                return this.block.split(/(?=https?)/u)
            },
        },

        methods: {
            /**
             * URL判定
             *
             * @param {string} str
             * @return {boolean}
             */
            isUrl: function (str) {
                return !!str.match(/^https?:\/\/[a-z0-9\-]+\.[a-z]+.*[ 　]?$/u)
            },
        },
    }
</script>
